export const status_update_form = {
  body_label: "Update",
  body_placeholder: "Describe progress for the seller…",
};
